import { useEffect, useState } from 'react';
export const useLocalStorage = (initialValue, keyValue, factory) => {
  const [key, setKey] = useState(keyValue);
  useEffect(() => {
    setKey(keyValue);
  }, [keyValue]);
  const readValue = () => {
    try {
      if (!key) return initialValue;
      const item = localStorage.getItem(key);
      if (factory) return factory(item, initialValue);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.warn("Error reading localStorage key \u201C".concat(key, "\u201D:"), error);
      return initialValue;
    }
  };
  const [storedValue, setStoredValue] = useState(readValue);
  const setValue = value => {
    try {
      if (!key) return;
      const newValue = value instanceof Function ? value(storedValue) : value;
      localStorage.setItem(key, JSON.stringify(newValue));
      setStoredValue(newValue);
      window.dispatchEvent(new Event('local-storage'));
    } catch (error) {
      console.warn("Error setting localStorage key \u201C".concat(key, "\u201D:"), error);
    }
  };
  useEffect(() => {
    setStoredValue(readValue());
  }, [key]);
  useEffect(() => {
    const handleStorageChange = () => {
      setStoredValue(readValue());
    };
    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('local-storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('local-storage', handleStorageChange);
    };
  }, [key]);
  return [storedValue, setValue];
};